<template>
    <div :class="'codigo-' + direccion_campo">
        <div id="cesped-recinto" :style="manager.tipo == 2 ? 'background-color: black; border: none;' : ''">
            <span></span>
            <span></span>
            <template v-if="tipo_recinto">
                {{ tipo_recinto }}
            </template>
            <template v-else>
                <template v-if="manager.tipo == 1">{{ textosTeatro.t('general.terreno_juego') }}</template>
                <template v-else>
                    <span class="text-uppercase">{{ $t('general.escenario') }}</span>
                </template>
            </template>
        </div>
    </div>
</template>

<script>
    import { useTextosTeatro } from '@/composables/common/useTextosTeatro';
    export default {
        props: {
            direccion_campo: {
                required: false,
                type: Number
            },
            tipo_recinto: {
                required: false,
                type: String,
                default: null
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            },
            textosTeatro() {
                return useTextosTeatro(this.$i18n, this.teatro?.hash);
            },
            manager() {
                return this.$store.getters.getFooter
            }
        }
    }
</script>

<style scoped>
    #cesped-recinto {
        background: black;
        color: #ffffff;
        padding-top: 30px;
        margin: 10px 0px 10px;
        border: 3px solid black;
        /* border-radius: 0 0 20px 20px; */
        border-top: none;
        font-size: 41px;
        letter-spacing: 0;
        font-weight: bold;
        min-height: 100px;
        font-size: 25px;
        TEXT-ALIGN: center;
        align-items: center;
        text-transform: uppercase;
        }
</style>